import { render, staticRenderFns } from "./AccountActivationView.vue?vue&type=template&id=60acb35b&scoped=true"
import script from "./AccountActivationView.vue?vue&type=script&lang=js"
export * from "./AccountActivationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acb35b",
  null
  
)

export default component.exports